import { SAVE_SEARCH_USERS, SAVE_USER } from '../constants/actionTypes'

export const initUser = user => ({
  type: SAVE_USER,
  user,
})

export const setSearchUsers = searchUsers => ({
  type: SAVE_SEARCH_USERS,
  searchUsers,
})
